<template>
  <invoice-manage :direction="1"></invoice-manage>
</template>

<script>
import InvoiceManage from './InvoiceManage';

export default {
  name: 'OutputInvoice',
  components: {
    InvoiceManage
  }
}
</script>
